export default {
  name: 'ClickSection',
  props: ['section', 'isDropDown', 'isOpen', 'content'],
  methods: {
    githubRD() {
      window.open('https://github.com/Devin-Harris/SudokuSolver')
    }
  }
}